// src/pages/Welcome.js
import React, { useState, useEffect } from 'react';
import { Typography, Container, Box, Paper, TextField, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Welcome = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [nameInput, setNameInput] = useState('');

  // Check if there's a name in the URL parameters
  useEffect(() => {
    const nameFromUrl = searchParams.get('name');
    if (nameFromUrl) {
      setNameInput(nameFromUrl);
      // Automatically navigate to the message page
      navigate(`/${nameFromUrl}`, { replace: true });
    }
  }, [searchParams, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (nameInput.trim()) {
      navigate(`/${nameInput.trim()}`);
    }
  };

  return (
    <Container maxWidth="md">
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        textAlign="center"
      >
        <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
          <Typography variant="h2" component="h1" gutterBottom color="primary">
            Welcome to GoAway.name
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom color="text.secondary">
            The friendliest way to tell someone to go away!
          </Typography>
        </Paper>

        <Paper elevation={2} sx={{ p: 3, width: '100%', maxWidth: 400 }}>
          <Typography variant="h6" gutterBottom>
            Try a name:
          </Typography>
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Enter a name"
              variant="outlined"
              value={nameInput}
              onChange={(e) => setNameInput(e.target.value)}
              sx={{ mb: 2 }}
              placeholder="e.g., John, Sarah, Mike..."
            />
            <Button 
              type="submit" 
              variant="contained" 
              fullWidth 
              size="large"
              disabled={!nameInput.trim()}
            >
              Check Name
            </Button>
          </Box>
        </Paper>

        <Box mt={3}>
          <Typography variant="body2" color="text.secondary">
            Share a direct link: goaway.name?name=Ruby
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Or use: goaway.name/Ruby
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Welcome;
